<template>
    <div :class="containerClass">
        <div :class="wrapperClass" v-if="type !== 'upgrade'">
            <img class="img-circle profile-image" :src="imageDataUrl" alt="profile image">
            <img class="profile-image-edit-icon" src="/dist/site/static/icons/camera.svg" @click="toggleShow" alt="Edit image">
        </div>

        	<div class="img-responsive margin-bottom-10" v-if="type === 'upgrade'">
            <img :src="imageDataUrl" class="center-block" alt="profile image">
        </div>
        <p v-if="type === 'upgrade'" class="upload-text"> Upload your picture <span  @click="toggleShow"> here </span> </p>
        <p v-if="type === 'upgrade'" class="supported-text"> Supports: .JPG, .JPEG, .PNG </p>
        <p v-if="type === 'upgrade'" class="supported-text">Recommended size:  < 2MB  </p>

        <vue-image-crop-upload field="profile_image"
                               @crop-success="cropSuccess"
                               @crop-upload-success="cropUploadSuccess"
                               @crop-upload-fail="cropUploadFail"
                               v-model="show"
                               :max-size="maxSize"
                               :url="endpoint"
                               :params="params"
                               :headers="headers"
                               img-format="png"
                               langType="en"
                               method="POST"
        ></vue-image-crop-upload>
    </div>

    
</template>

<script>
  import VueImageCropUpload from 'vue-image-crop-upload'

  const defaultImageUrl = '/dist/site/static/icons/default-avatar.svg'

  export default {
    name: 'ProfileImage',

    props: {
      'imageSrc': String,
      'endpoint': String,
      'size': String,
      'type': String,
    },

    beforeMount () {
      this.imageDataUrl = this.imageSrc

      if (_.isEmpty(this.imageDataUrl)) {
        this.imageDataUrl = defaultImageUrl
      }

      let token = document.head.querySelector('meta[name="csrf-token"]')
      if (token) {
        this.headers = { 'X-CSRF-TOKEN': token.content}
      }

      if (this.size === 'small' && _.isEmpty(this.type)) {
        this.wrapperClass = 'profile-image-wrapper-small'
      }

      if(this.type === 'upgrade') {
        this.containerClass = 'width-100 image-upload-wrapper'
        this.wrapperClass = ''
      }

    },

    mounted () {
      this.params._token = $('meta[name="csrf-token"]').attr('content')
      this.loading = false
    },

    data: () => ({
      loading: true,

      show: false,

      params: {
        _token: null,
      },

      headers: {},

      imageDataUrl: null,

      maxSize: 2048,

      wrapperClass: 'profile-image-wrapper',

      containerClass: ''
    }),

    components: {
      'vue-image-crop-upload': VueImageCropUpload
    },

    methods: {

      toggleShow () {
        this.show = !this.show
      },

      /**
       * crop success
       *
       * [param] imgDataUrl
       * [param] field
       */
      cropSuccess (imgDataUrl, field) {
        this.imageDataUrl = imgDataUrl
      },

      /**
       * upload success
       *
       * [param] jsonData  server api return data, already json encode
       * [param] field
       */
      cropUploadSuccess (jsonData, field) {},

      /**
       * upload fail
       *
       * [param] status    server api return error status, like 500
       * [param] field
       */
      cropUploadFail (status, field) {}

    },

    watch: {
      loading (to, from) {
        this.$emit('componentLoading', this.$options.name, to)
      }
    }
  }
</script>

<style lang="scss" scoped>
    .profile-image-wrapper {
        position: relative;
        max-width: 200px;
    }

    .profile-image {
        padding: 4px;
        line-height: 1.6;
        display: inline-block;
        min-width: 200px;
        max-width: 100%;
        height: 150px;
    }

    .profile-image-edit-icon:hover {
        cursor: pointer;
        color: #003b71;
    }

    .image-upload-wrapper {
      height: auto; 
      border: dashed; 
      border-color: #D7DEE3;     
      display: flex;
      flex-direction: column;
      padding: 2rem;
      align-items: center;
  	}

    	.upload-text {
		font-family: Circular Std;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 15px;
		text-align: center;
		letter-spacing: -0.01em;
		color: #949494;
	}
	
  .center-block {
    max-width: 100px;
  }

	.upload-text span {
		color: #1781EF;
	}

  .supported-text {
		font-family: Circular Std;
		font-style: normal;
		font-weight: normal;
		font-size: 10px;
		line-height: 12px;
		text-align: center;
		letter-spacing: 0.1px;
		color: #949494;
		}

    .profile-image-edit-icon {
        position: absolute;
        bottom: 0px;
        right: 5px;
        border-radius: 50%;
        display: flex !important;
        align-items: center;
        justify-content: center;
    }

    .profile-image-wrapper-small {
        position: relative;
        width: 150px;

        .profile-image {
            min-width: 150px;
        }

        .profile-image-edit-icon {
            bottom: -6px;
            right: -20px;
        }
    }
</style>
